import React from 'react'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { Field, reduxForm} from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
import '../../assets/css/requisition.css'
import {
    renderTextField,
    renderRadioGroup,
    renderDatePicker
} from '../form/RenderComponent'
import { 
    Radio,
    FormControlLabel,
    FormControl,
    FormLabel,
    Button
} from '@material-ui/core'
import  {
    jobInformationValidation
} from "../form/Validation"
import MomentUtils from '@date-io/moment'
import {
    MuiPickersUtilsProvider
} from 'material-ui-pickers'
import '../../assets/css/datePicker.css'
let JobInformationForm = (props) => {

    const {classes, handleSubmit, pristine, submitting,back, jobType } = props
   
    return (
        
        <form className={classes.form} >
            <GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="number_of_positions"
                        component={renderTextField}
                        type="number"
                        label="No of Positions Required"
                    />
                </GridItem>
                
                <GridItem xs={12} sm={12} md={12}>
                    <div>
                        
                        <GridContainer>

                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl >
                                    <FormLabel>Reason for Replacement</FormLabel>
                                    <Field
                                        name="type" 
                                        component={renderRadioGroup} 
                                    >

                                        <FormControlLabel
                                            label="New"
                                            value="1"
                                                control = {
                                                    <Radio  color="secondary"/>
                                            }
                                        />
                                    
                                        <FormControlLabel
                                            label="Resignation"
                                            value="0"
                                                control = {
                                                    <Radio  color="secondary"/>
                                            }
                                        />
                                        
                                        <FormControlLabel
                                            label="Retirement"
                                            value="-1"
                                            control = {
                                                <Radio  color="secondary"/>
                                            }
                                            
                                        />  

                                        <FormControlLabel
                                            label="Sabbatical"
                                            value="-2"
                                            control = {
                                                <Radio color="secondary"/>
                                            }
                                            
                                        />  

                                        <FormControlLabel
                                            label="Termination"
                                            value="-3"
                                            control = {
                                                <Radio color="secondary" />
                                            }
                                        />  
                                    
                                    </Field>
                                </FormControl>
                            </GridItem>

                        </GridContainer>
                    </div>
                </GridItem>

                {
                    jobType && (
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                style={classes.input}
                                name="employee_name"
                                component={renderTextField}
                                label="If Replacement, Employee Name"
                            />
                        </GridItem>  
                    )
                }
                

                <GridItem xs={12} sm={12} md={12}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Field
                            name="target_date"
                            component={renderDatePicker}
                            label="Target date for Commencement"
                            placeholder="Choose Date"
                            className="date-picker"
                        />
                    </MuiPickersUtilsProvider>
                </GridItem>
                
                <GridItem xs={12} sm={6} md={6}>
                      <div className="Button-Holder">
                        <Button
                          type="button"
                          className={classes.prev_button}
                          variant="contained"
                          onClick={() => back()}
                          >
                          Previous
                        </Button>
                      </div>
                      
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div className="Button-Holder">
                      <Button
                        className={classes.button}
                        disabled={pristine || submitting}
                        // type="submit"
                        // onClick={()=>next()}
                        onClick={handleSubmit}
                        variant="contained"
                        color ="secondary"
                        >
                            Next
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>
        </form> 
    )
} 

JobInformationForm.propTypes = {
    classes: PropTypes.object.isRequired
}

JobInformationForm = reduxForm({
    form: "JobInformation",
    destroyOnUnmount: false,        
    forceUnregisterOnUnmount: true,
    validate: jobInformationValidation,
    enableReinitialize: false,
    // initialValues:{
    //     type: "-4"
    // }
})(withStyles(requisitionFormStyle) (JobInformationForm))

export default JobInformationForm






















